<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :data-tour="item.route === 'movies' ? 'sidebar-movies-menu' : null"
    :class="{
      'active': isActive,
      'disabled': item.disabled || isMenuDisabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      :tabindex="isMenuDisabled ? -1 : null"
      :aria-disabled="isMenuDisabled ? 'true' : 'false'"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
        class="text-success"
      />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { computed } from '@vue/composition-api'
import { isSidebarItemEnabled } from '../../sidebar-menu-access'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    const isMenuDisabled = computed(() => !isSidebarItemEnabled(props.item))

    return {
      isActive,
      isMenuDisabled,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
